import React from 'react';
import Modal from '../../Modal';
import './StorefrontManager.css';

function normalizePreviewUrl(url) {
    if (!url) return url;
    const currentProtocol = typeof window !== 'undefined' ? window.location?.protocol : '';
    if (currentProtocol !== 'https:' || !String(url).startsWith('http://')) return url;

    try {
        const parsed = new URL(url);
        parsed.protocol = 'https:';
        return parsed.toString();
    } catch {
        return String(url).replace(/^http:\/\//i, 'https://');
    }
}

function normalizeScale(scale) {
    const parsed = Number(scale);
    if (!Number.isFinite(parsed) || parsed <= 0) return 1;
    return parsed;
}

export default function StorefrontPreview({ isOpen, onClose, url, version, onRefresh, showSavedMessage, scale = 1 }) {
    const previewUrl = normalizePreviewUrl(url);
    const frameScale = normalizeScale(scale);
    const frameStyle = frameScale === 1
        ? undefined
        : {
            height: `${100 / frameScale}%`,
            transform: `scale(${frameScale})`,
            transformOrigin: 'top left',
            width: `${100 / frameScale}%`,
        };
    const footer = (
        <>
            {previewUrl ? <a className="button secondary" href={previewUrl} target="_blank" rel="noreferrer">Open Storefront</a> : null}
            <button type="button" className="button secondary" onClick={onRefresh} disabled={!previewUrl}>Refresh Preview</button>
            <button type="button" className="button primary" onClick={onClose}>Close</button>
        </>
    );

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Saved Storefront Preview"
            size="fullscreen"
            className="sfm-preview-modal"
            footer={footer}
            ariaDescribedBy="sfm-preview-description"
        >
            <p id="sfm-preview-description" className="help sfm-preview-description">
                This preview shows the currently saved public storefront.
            </p>
            {showSavedMessage ? (
                <p className="sfm-preview-saved-message" role="status">
                    Changes saved. Preview refreshed.
                </p>
            ) : null}
            {previewUrl ? (
                <div className="sfm-preview-frame-shell" aria-label="Storefront preview">
                    <iframe
                        key={`${previewUrl}-${version}`}
                        className="sfm-preview-frame"
                        src={previewUrl}
                        title="Saved storefront preview"
                        loading="lazy"
                        scrolling="yes"
                        referrerPolicy="no-referrer-when-downgrade"
                        style={frameStyle}
                    />
                </div>
            ) : (
                <div className="sfm-preview-empty">
                    <p className="help">Save a storefront URL to preview the public page.</p>
                </div>
            )}
        </Modal>
    );
}
